export function generatePasskeyName(): string {
  const date = new Date().toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
  return `Cool Mate - ${date}`;
}
